(function () {
  if (window.__frzCart) return;
  window.__frzCart = true;
  var busy = false;
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function post(url, data) {
    return fetch(root + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function isCartPage() {
    return !!document.getElementById('main-cart-items');
  }

  function refresh() {
    if (isCartPage()) { window.location.reload(); return Promise.resolve(); }
    var drawer = document.querySelector('cart-drawer');
    return fetch(root + '?sections=cart-drawer,cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var p = new DOMParser();
        if (s['cart-icon-bubble']) {
          var bubble = document.getElementById('cart-icon-bubble');
          var nb = p.parseFromString(s['cart-icon-bubble'], 'text/html').querySelector('.shopify-section');
          if (bubble && nb) bubble.innerHTML = nb.innerHTML;
        }
        if (drawer && s['cart-drawer']) {
          var doc = p.parseFromString(s['cart-drawer'], 'text/html');
          var inner = doc.getElementById('CartDrawer');
          var cur = document.getElementById('CartDrawer');
          if (inner && cur) cur.innerHTML = inner.innerHTML;
          var nd = doc.querySelector('cart-drawer');
          if (nd) drawer.classList.toggle('is-empty', nd.classList.contains('is-empty'));
        }
      });
  }

  function enforceGift() {
    if (busy) return;
    var el = document.querySelector('[data-cart-rewards]');
    if (!el) return;
    var lines = (el.dataset.giftLines || '').split(',').filter(Boolean).map(function (x) {
      var i = x.lastIndexOf(':');
      return { key: x.slice(0, i), qty: parseInt(x.slice(i + 1), 10) };
    });
    if (!lines.length) return;
    var eligible = el.dataset.eligible === 'true';
    var total = parseInt(el.dataset.giftQty || '0', 10);
    var change = null;
    if (!eligible) change = { id: lines[0].key, quantity: 0 };
    else if (lines.length > 1) change = { id: lines[lines.length - 1].key, quantity: 0 };
    else if (total > 1) change = { id: lines[0].key, quantity: 1 };
    if (!change) return;
    busy = true;
    post('cart/change.js', change).then(refresh).finally(function () { busy = false; });
  }

  function loadRecs() {
    document.querySelectorAll('[data-cart-recs]:not([data-loaded])').forEach(function (box) {
      box.setAttribute('data-loaded', '1');
      if (isCartPage() && !box.closest('cart-drawer')) box.classList.add('frz-recs--page');
      var pid = box.dataset.productId;
      fetch(root + 'recommendations/products?product_id=' + pid + '&limit=8&section_id=frz-cart-recommendations')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var d = new DOMParser().parseFromString(html, 'text/html').querySelector('.frz-recs__inner');
          if (d) box.innerHTML = d.innerHTML;
        })
        .catch(function () {});
    });
  }

  document.addEventListener('click', function (e) {
    var gift = e.target.closest('[data-gift-variant]');
    var add = e.target.closest('button[data-recs-add]');
    var btn = gift || add;
    if (!btn) return;
    e.preventDefault();
    if (busy) return;
    busy = true;
    btn.classList.add('is-loading-frz');
    var item = { id: parseInt(btn.dataset.giftVariant || btn.dataset.recsAdd, 10), quantity: 1 };
    if (gift) item.properties = { _regalo: 'Sí' };
    post('cart/add.js', { items: [item] })
      .then(function (res) {
        if (res && res.status && res.description) console.warn('[frz-cart]', res.description);
        return refresh();
      })
      .finally(function () { busy = false; btn.classList.remove('is-loading-frz'); });
  });

  var t;
  function tick() { clearTimeout(t); t = setTimeout(function () { enforceGift(); loadRecs(); }, 200); }
  new MutationObserver(tick).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tick); else tick();
})();